import { useState } from "react"
import { trailerSource } from "../lib/trailerSource"

export default function TrailerPlayer({ src, title, className }: { src: string; title: string; className: string }) {
    const source = trailerSource(src)
    const [failedSrc, setFailedSrc] = useState<string | null>(null)
    if (!source || failedSrc === src) {
        return <div className={`${className} flex items-center justify-center p-6 text-center text-sm text-white/80`} role="status">
            Трейлер временно недоступен. Попробуйте позже.
        </div>
    }
    if (source.kind === "video") {
        return <video
            key={src}
            src={source.url}
            aria-label={`Трейлер: ${title}`}
            className={className}
            controls
            autoPlay
            playsInline
            preload="metadata"
            onError={() => setFailedSrc(src)}
        />
    }
    return <iframe
        src={source.url}
        title={`Трейлер: ${title}`}
        className={className}
        allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
        allowFullScreen
    />
}
